import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  error: null,
  message: null,
};

export const grantUserRolesSlice = createSlice({
  name: "grantUserRoles",
  initialState,
  reducers: {
    grantUserRolesRequested: (state) => {
      state.status = "loading";
      state.error = null;
      state.message = null;
    },
    grantUserRolesRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    grantUserRolesRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.message = action.payload;
    },
  },
});

export const {
  grantUserRolesRequested,
  grantUserRolesRequestFailed,
  grantUserRolesRequestSucceeded,
} = grantUserRolesSlice.actions;

export default grantUserRolesSlice.reducer;
